import { render, staticRenderFns } from "./add_jbxx.vue?vue&type=template&id=ea9bfb1e&scoped=true&"
import script from "./add_jbxx.vue?vue&type=script&lang=js&"
export * from "./add_jbxx.vue?vue&type=script&lang=js&"
import style0 from "./add_jbxx.vue?vue&type=style&index=0&id=ea9bfb1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea9bfb1e",
  null
  
)

export default component.exports